<div class="wrapper">
  <mat-accordion  *ngFor="let job of jobList">
    <app-job-panel [job]="job"></app-job-panel>
  </mat-accordion>
  <br/>
  <button mat-raised-button
          [disabled]="this.loadMoreDisabled"
          (click)="loadMoreResults()">Load more</button>
</div>